import React, {useState} from "react";
import About from "../About/About";
import Portfolio from "../Portfolio/Portfolio";
import { Link } from "react-scroll";
import image1 from "../../images/ppbackground.png";
import Socmedialinks from "../Socmedialinks/Socmedialinks";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";





      


export default function Landing() {

  const refresh = () => window.location.reload(true)

  const [btnState, setBtnState] = useState(false)

  function handleClick12(){
      setBtnState(btnState => !btnState)
  }


  let toggleClassCheck = btnState ? ' nav-list' : 'nav-list-hide'  // or null


  return (
    <div>
   
      <div className="landing-body">
        <div id="landing">

      {/* Andrejs Grocs Tag */}

  

        {/* NAV */}
        
        <nav className="nav">
        
        <Link className="andrejs-grocs-tag"
           onClick={refresh}



          //  activeClass="active"
          //     to="landing-body"
          //     spy={true}
          //     smooth={true}
          //     offset={50}
          //     duration={50}
              
              >
              
        <div className="andrejs-tag-text-content">
    
       
      <p className="andrejs">Andrejs</p>
      <p className="andrejs">Grocs</p>

    </div>
  </Link>
  

      <div className="label">
  <label for="check">

  <input type="checkbox" id="check" onClick={handleClick12}/> 
  
      <span className="hamburger-span"></span>
      <span className="hamburger-span"></span>
      <span className="hamburger-span"></span>
  </label>
  </div>


          <ul  className={`nav-list ${btnState ? 'nav-list':'nav-list-hide'}`}>
      

            <li>
              

            </li>
              
            <li >  <a className="btn-home" >
            <Link
              activeClass="active"
              to="landing-body"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              HOME
            </Link>
          </a></li>


          <li >  <a className="btn1" >
            <Link
              activeClass="active"
              to="page1"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              ABOUT
            </Link>
          </a></li>

          
            <li> <a className="btn2">
            <Link
              activeClass="active"
              to="page2"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              PORTFOLIO
            </Link>
          </a></li>


            <li>      <a className="btn3">
            <Link
              activeClass="active"
              to="page3"
              spy={true}
              smooth={true}
              offset={50}
              duration={500}
            >
              CONTACT
            </Link>
          </a></li>
         
          </ul>
          </nav>


        {/* Image */}

      </div>
        <img className="image1" src={image1} />
      </div>

      <Socmedialinks/>
   
      

      {/* Links To Sections */}

      <div id="page1">
      <About/>
        
      </div>

      <div id="page2">
      <Portfolio />
      </div>

      <div id="page3">
        <Contact/>
        <Footer/>





      </div>
    </div>
  );
}